import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/useAuth";
import CreditHud from "./CreditHud";
import RenderTargetToggle from "./RenderTargetToggle";

// DirectorStudioShell — the Director console IS the workspace. Everything
// (uploads, storyboard BOARD, approvals, render) happens inside the console,
// so there is no side rail and no separate storyboard strip out here. Just a
// thin credit HUD above a full-width, full-height console.

export default function DirectorStudioShell({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();

  return (
    <section id="director-studio" className="mx-auto w-full text-left">
      {/* Which GPU renders, and whether it can actually take a job. Sits beside
          the credit HUD because both answer "what will this cost me". */}
      <div className="flex flex-wrap items-start justify-between gap-3">
        <CreditHud isAuthenticated={isAuthenticated} />
        {isAuthenticated && <RenderTargetToggle />}
      </div>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="relative mt-4 min-w-0" >
        {children}
      </motion.div>
    </section>
  );
}
